import { render, staticRenderFns } from "./VolunteerDashboardCountBoard.vue?vue&type=template&id=023b7704&"
import script from "./VolunteerDashboardCountBoard.vue?vue&type=script&lang=ts&"
export * from "./VolunteerDashboardCountBoard.vue?vue&type=script&lang=ts&"
import style0 from "./VolunteerDashboardCountBoard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports